import { useEffect, useState } from "react";
import moment from "moment";
import "./Footer.scss";
import packegeJson from "../../../../package.json";
import { useAppSelector } from "../../../services/hooks.service";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { ALGO_NETWORK } from "../../../constants/constants";

export const FooterTimer = ({ showData = true }) => {
  const { t } = useTranslation();
  const [date, setDate] = useState(getTime());
  const appTitle = useAppSelector((state) => state.settings.appTitle);

  function getTime() {
    return moment().utc().format('MM/DD/YYYY HH:mm:ss');
  };

  const renderTooltip = (props) => {
    return (
      <Tooltip className="ioc-tooltip mainnet_tooltip" {...props}>
        <div>{ ALGO_NETWORK !== 'MainNet'
        ? t("footer.trading_on_testnet")
        : t("footer.trading_on_mainnet") 
        }</div>
      </Tooltip>
    );
  };

  useEffect( () => {
    if (!showData) return;
    setInterval(()=>{
      setDate(getTime())
    }, 1000)
  }, []);

  return (
    <>
      <span className="mainnet_info">
        <OverlayTrigger placement="top" overlay={renderTooltip}>
          <i className="far fa-info-circle"></i>
        </OverlayTrigger>
        {ALGO_NETWORK !== 'MainNet'
          ? "TESTNET"
          : "MAINNET"
        } 
        {ALGO_NETWORK === 'MainNet' && <span>BETA</span>}
      </span>
      <span className="copyright">
        © {new Date().getFullYear()} {appTitle}
        {" v"}
        {packegeJson?.version} 
        {showData && <span className="copyright_time">{date} UTC</span>}
      </span>
    </>
  );
};
